/*  ========================================================================
    # Scripts - Video with Thumbnail
    ========================================================================  */

/**
 * Script that handles the video thumbnail logic for video component.
 */
const VideoWithThumbnail = {
  cfg: {
    components: document.querySelectorAll('.c-video:has(> button)')
  },

  handleVideoButtonClick(component) {
    const button = component.querySelector('button');

    button.addEventListener('click', () => {
      const video = component.querySelector('video');
      video.setAttribute('controls', 'controls');
      video.play();
      button.style.display = 'none';
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.components) {
      this.cfg.components.forEach(component => {
        this.handleVideoButtonClick(component);
      });
    }
  }
};

export default VideoWithThumbnail;
